export const IValidationRepositoryType = Symbol('IValidationRepository');
